/**
 * NotificationFilterTabs — "Tümü (N)" / "Okunmamış (N)" segment sekmeleri.
 *
 * İstemci-taraflı filtre (backend'de ayrı bir filtre endpoint'i yok — mevcut
 * GET /api/notifications limit=50 sabit döner). N===50 ise "50+" gösterilir;
 * gerçek toplam bilinmediği için yanlış kesinlik iddiası yapılmaz.
 */
import { useLanguage } from '../../contexts/LanguageContext';

const COUNT_CAP = 50;

function formatCount(n) {
  return n >= COUNT_CAP ? `${COUNT_CAP}+` : String(n);
}

export default function NotificationFilterTabs({ filter, onChange, allCount, unreadCount }) {
  const { t } = useLanguage();

  const tabs = [
    { key: 'all', label: t('cabin.notifications.filter.all'), count: allCount },
    { key: 'unread', label: t('cabin.notifications.filter.unread'), count: unreadCount },
  ];

  return (
    <div
      role="tablist"
      aria-label={t('cabin.notifications.filter.aria_label')}
      className="flex items-center gap-1.5 px-3 py-2 border-b border-gray-100 shrink-0"
    >
      {tabs.map((tab) => {
        const active = filter === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.key)}
            className={`px-3 py-2 min-h-[40px] rounded-full text-xs font-bold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)] ${
              active
                ? 'bg-[var(--brand-primary)] text-white'
                : 'bg-gray-100 text-[var(--text-secondary)] hover:bg-gray-200'
            }`}
          >
            {tab.label} ({formatCount(tab.count)})
          </button>
        );
      })}
    </div>
  );
}
